import React, { useState } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

// Small inline "copy to clipboard" icon — used next to AWBs and similar codes.
// Stops row-click propagation so it's safe inside clickable table rows.
export default function CopyIcon({ text, title = 'Copy AWB', size = 14, color = 'text.secondary' }) {
  const [copied, setCopied] = useState(false);
  if (!text) return null;
  const onCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      navigator.clipboard?.writeText(String(text));
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) { /* clipboard unavailable */ }
  };
  return (
    <Tooltip title={copied ? 'Copied' : title}>
      <IconButton size="small" onClick={onCopy} sx={{ p: '2px', ml: '2px' }} aria-label="copy to clipboard">
        {copied
          ? <CheckIcon sx={{ fontSize: size, color: 'success.main' }} />
          : <ContentCopyIcon sx={{ fontSize: size, color }} />}
      </IconButton>
    </Tooltip>
  );
}
